import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { format, toInt, format_display_fancy_notime_withDay } from '../Utils';
import { Grid, Divider, Fade, FormControl, Select, InputLabel, AppBar, Toolbar, List, ListItemText, TextField, Tooltip, Icon, Hidden, CircularProgress, OutlinedInput } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from "@date-io/moment";
import AutoCompleteSelection from "./AutoCompleteSelection";
import moment from 'moment';
import { WarehouseService } from '../Services/WarehouseService';

let counter = 0;

const useStyles = makeStyles(theme => ({
    appBar: {
        position: 'relative',
        marginBottom: 10
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    sectionHeading: {
        fontSize: theme.typography.pxToRem(18),
        fontWeight: theme.typography.fontWeightMedium,
    },
    heading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightMedium,
    },
    subheading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightRegular,
        textAlign: "left"
    },
    formControl: {
        margin: theme.spacing(0),
        minWidth: 200,
    },
    formControlBig: {
        margin: theme.spacing(0),
        minWidth: 280,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    autoCompleteSelectionTextField: {

    }
}));

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function VerifyPhysicalStockDialog(props) {
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const [title, setTitle] = React.useState(undefined);
    const [details, setDetails] = React.useState([]); 
    const [transaction, setTransaction] = React.useState({txn_date: moment(), source_id: '', stock_type: '', products: []});
    const [tproducts, setTProducts] = React.useState([]); 

    const [sources, setSources] = React.useState([]);
    const [stockType, setStockType] = React.useState([]);
    const [products, setProducts] = React.useState([]);
    const [addItemRows, setAddItemRows] = React.useState([]);

    const classes = useStyles();

    React.useEffect(() => {
        setOpen(props.open);
    }, [props.open]);

    React.useEffect(() => {
        if(props.source_names){
            setSources(props.source_names);
            setStockType(props.stock_type_rows);
            setProducts(props.master_products.filter(p => p.status !== -1).map((element) =>(
                ({key: element.id, id: element.id, name: element.name, value: element.name, label: element.name, unit: element.unit_size, display_name: element.display_name})
            )));
        }
    }, [props.source_names, props.master_products, props.stock_type_rows]);

    function handleSourceSelection(e) {
        setTransaction({...transaction, source_id : e.target.value, source_type: "WAREHOUSE"});
    }

    function handleStockTypeSelection(e) {
        setTransaction({...transaction, stock_type : e.target.value});
    }

    const handleProductSelection = (product) => {
        // let p = tproducts;
        // tproducts.push();
        // updateUI(tproducts);
        setTProducts(tproducts => [...tproducts, {rowid: counter++, product_id: product.id, actual_qty: 0, physical_qty: 0, reason: '-1', name: product.name, display_name: product.display_name, unit_size: product.unit_size, comments: product.comments, modified: false}]);
    }

    const updateUI = () => {
        setAddItemRows(tproducts.map((product, index) => {  
            return(
                <ItemDetails index={index + 1} key={index + 1 + product.product_id} current_stock={product.actual_qty} product={product} removeProduct={removeProduct} handleProductChange={handleProductChange}/>
            ); 
        }));
    }

    const handleProductChange = (product, e, field) => {
        let pL = tproducts.filter(p => p.rowid === product.rowid);
        pL[0][field] = e.target.value || 0;
        pL[0].modified = true;
        // updateUI(tproducts);
        setTProducts(tproducts);
    }

    const removeProduct = (product, e) => {
        props.showConfirmDialog("Confirm Remove?", undefined, () => {

            setTProducts(tproducts.filter(p => p.rowid !== product.rowid));

            // let index = tproducts.findIndex(p => p.rowid === product.rowid);
            // tproducts.splice(index, 1);
            // setTProducts(tproducts);
            // updateUI(tproducts);
            props.closeConfirmDialog();
        });
    }

    React.useEffect(() => {
        WarehouseService.getStock(transaction.source_id)
        .then(data => {
            console.log(data);
            transaction.current_stock = data.stock;
            setTransaction(transaction);
        });
    }, [transaction.source_id]);


    function ItemDetails(props) {
        const {product, index, removeProduct, current_stock, handleProductChange} = props;
        return(
            <Grid container spacing={1} key={product.id}>
                <Grid item xs={6} lg={3} style={{marginTop: 24}}>
                    <ListItemText 
                        primary={<Typography type="subtitle1">{index}{". "}{product.display_name ? product.display_name: product.name}</Typography>} 
                        secondary={`Current Stock ${current_stock}`} />
                </Grid>
                <Grid item xs={6} lg={2}>
                    <TextField
                        fullWidth
                        id="standard-number"
                        label="Qty"
                        defaultValue={product.modified ? product.actual_qty : 0}
                        onChange={(e) => handleProductChange(product, e, 'physical_qty')}
                        type="number"
                        name={product.id}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{ min: 0 }}
                        className={classes.qtyField}
                        margin="normal"
                        variant="outlined"
                        required
                        helperText={`Unit size: ${product.unit_size ? product.unit_size : ""}`}
                        style={{minWidth: 100}}
                    />
                </Grid>
                <Grid item xs={2} lg={1} style={{marginTop: 16}}>
                    <Tooltip title="Remove">
                        <IconButton aria-label="Delete" onClick={(e) => removeProduct(product, e)} className={classes.icon}>
                            <Icon>delete</Icon>
                        </IconButton>
                    </Tooltip>
                </Grid>
                <Hidden mdUp>
                    <Grid item xs={12} style={{marginTop: 8}}>
                        <Divider />
                    </Grid>
                </Hidden>
            </Grid>
        );
    }

    React.useEffect(() => {
        updateUI();
    }, [tproducts]);

    function search(e) {
        WarehouseService.getStock(transaction.source_id)
        .then(data => {
            console.log(data);
            let tproducts = [];
            data.stock.filter(s => s.stock_type === transaction.stock_type).forEach((stock) => {
                let product = props.master_products.filter(p => p.id === stock.product_id)[0];
                tproducts.push({rowid: counter++, product_id: stock.product_id,  actual_qty: toInt(stock.qty), physical_qty: toInt(stock.qty), name: stock.product_name, display_name: product.display_name || '', unit_size: product.unit_size || '', modified: true});
            });
            setTProducts(tproducts);
            setLoading(false);
        });
    }

    React.useEffect(() => {
        let details = [];
        setTitle(`Verify Stock for - ${moment(transaction.txn_date).format(format_display_fancy_notime_withDay)}`);

        details.push(
        <Grid item container xs={12} lg={12} key={1} spacing={2} alignItems="center">
            <Grid item xs={12} lg={3}>
                <FormControl variant="outlined" className={classes.formControlBig}>
                    <InputLabel
                        htmlFor="outlined-warehouse-simple"
                    >
                        Warehouse
                    </InputLabel>
                    <Select
                        value={transaction.source_id}
                        onChange={handleSourceSelection}
                        input={
                        <OutlinedInput
                            labelWidth={50}
                            name="Warehouse"
                            id="outlined-source-simple"
                        />
                        }
                    >
                        {sources}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} lg={2} style={{zIndex: 5}}>
                <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel
                        htmlFor="outlined-txn_type-simple"
                    >
                        Stock Type
                    </InputLabel>
                    <Select
                        value={transaction.stock_type}
                        onChange={handleStockTypeSelection}
                        input={
                        <OutlinedInput
                            labelWidth={50}
                            name="Stock Type"
                            id="outlined-txn_type-simple"
                        />
                        }
                    >
                        {stockType}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={6} lg={2}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <DateTimePicker
                        label="Transaction Date"
                        inputVariant="outlined"
                        value={transaction.txn_date}
                        disabled
                        fullWidth
                        format='DD MMM YYYY'
                    />
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={2} lg={2}>
                <Button variant="contained" color="primary" onClick={search}>SEARCH</Button>
            </Grid>
            <Grid item xs={6} lg={2}>
                { (transaction.source_id && transaction.stock_type) &&
                <FormControl 
                    fullWidth 
                    className={classes.formControlAutoComplete} 
                    style={{zIndex: 2}}>
                    <AutoCompleteSelection
                        placeHolder="Select Product"
                        onChange={handleProductSelection}
                        name="product"
                        isMulti={false}
                        value={[transaction.products]}
                        options={products}/>
                </FormControl>
                }
            </Grid>
            <Grid item xs={12} lg={12}>
                <Divider variant="fullWidth" style={{marginBottom: 5, marginTop: 5}}/>
            </Grid>
        </Grid>);
        setDetails(details);

    }, [transaction, sources, products, stockType]);

const handleSave = () => {
    props.showConfirmDialog("Confirm?", undefined, () => {
        props.closeConfirmDialog();
        setLoading(true);
        save();
    });
}

const save = () => {
    let header = {'user-id' : props.user.id, 'user-name': props.user.name };
    let body = transaction;
    body.txn_date = moment(transaction.txn_date).utc().format(format)
    delete body.current_stock;
    body.products = tproducts.map(p => ({
        product_id: p.product_id,
        current_qty: p.actual_qty,
        qty: toInt(p.physical_qty)
    }));
    console.log(body);

    WarehouseService.updateStockMismatch(header, body)
    .then((data) => {
        if(data.success){
            props.showSnackBar(`Physical Stock details updated.`, 'success');
            props.save();
            props.close();
            setOpen(false);
            setTProducts([]);
            setAddItemRows([]);
            setTransaction({txn_date: moment(), source_id: '', stock_type: '', products: []});
        } else {
            props.showSnackBar(`Failed for one or more entries.`, 'error');
        }
        setLoading(false);
    })
    .catch((err) => {
        console.log(err);
        props.showSnackBar(`Failed to update Physical Stock details. Please check again or contact Admin.`, 'error');
        setLoading(false);
    });
}
 
const handleClose = () => {
    props.showConfirmDialog("Cancel?", "Confirm", () => {
        props.close();
        props.closeConfirmDialog();
        setOpen(false);
        setTProducts([]);
        setAddItemRows([]);
        setTransaction({txn_date: moment(), source_id: '', stock_type: '', products: []});
    });
};

  return (
      <Dialog fullScreen fullWidth maxWidth={"xl"} onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <AppBar className={classes.appBar}>
            <Toolbar>
            <IconButton color="inherit" onClick={handleClose} aria-label="Close">
                <CloseIcon />
            </IconButton>
            <Typography variant="h6" color="inherit" className={classes.flex}>
                {title}
            </Typography>
            </Toolbar>
        </AppBar>
        <DialogContent dividers>
            <Grid container justify="flex-start" alignItems="center" direction="row">
                <Grid item xs={12} lg={12}>
                    <Fade
                        in={loading}
                        style={{
                            transitionDelay: loading ? '10ms' : '0ms'
                        }}
                        unmountOnExit
                        >
                        <CircularProgress style={{position: "fixed", top: "50%", left: "50%"}}/>
                    </Fade>
                </Grid>
                {details}
                <Grid item xs={12}>
                    <List className={classes.list}>                               
                        {addItemRows}
                    </List>
                </Grid>
            </Grid>
            </DialogContent>
            <DialogActions>
                <Button 
                    autoFocus 
                    onClick={handleSave} 
                    color="primary" 
                    variant="contained"
                    disabled={!(transaction.source_id && transaction.stock_type && transaction.txn_date && tproducts.length > 0) || loading}>
                    Save
                </Button>
                <Button autoFocus onClick={handleClose} color="secondary" >
                    Close
                </Button>
            </DialogActions>
      </Dialog>
  );
}